import {
  ValuePropFilterOptionsCtaClick,
  ValuePropFilterOptionType,
} from '@rover/react-lib/src/pages/landing/utilities/analyticsEvents';
import type { ServiceTypeSlugEnum } from '@rover/rsdk/src/apiClient/latest/model/serviceTypeSlugEnum';

function onValuePropFilterOptionsCtaClick(serviceTypeSlug: ServiceTypeSlugEnum) {
  return (valuePropFilterOption: ValuePropFilterOptionType) => {
    new ValuePropFilterOptionsCtaClick({
      serviceTypeSlug,
      valuePropFilterOption,
    }).fireCrossPageEvent();
  };
}
export default onValuePropFilterOptionsCtaClick;
